import React__default, { useRef, useCallback, useEffect } from 'react';
import { useWasSeenByUser } from '@grandvisionhq/analytics';
import { pushPromotionClick, pushPromotionImpression } from '../utils/data-layer.js';
import { BannerRecommendation } from './BannerRecommendation.js';

const BannerRecommendationContainer = (props)=>{
    const { recommendation  } = props;
    const clickRef = useRef(false);
    const { ref , wasSeen  } = useWasSeenByUser();
    const handlePromotionClick = useCallback(()=>{
        if (!clickRef.current) {
            clickRef.current = true;
            pushPromotionClick(recommendation);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(()=>{
        if (wasSeen) {
            pushPromotionImpression(recommendation);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        wasSeen
    ]);
    return /*#__PURE__*/ React__default.createElement(BannerRecommendation, {
        ref: ref,
        recommendation: recommendation,
        onClick: handlePromotionClick
    });
};

export { BannerRecommendationContainer };
//# sourceMappingURL=BannerRecommendationContainer.js.map
